import { SchemaFormDefinition } from '@mews-commander/form';
import { compactArray } from '@mews/fp';
import { lt } from '@mews/framework';
import { FinancialDocumentPdfTemplateType } from '@mews-commander/data-access';
import { GroupOption, Option } from '@mews-commander/types';
import { FinancialDocumentTemplateSelectField } from '../fields/FinancialDocumentTemplateSelectField';
import { RecipientsChipInput } from '../fields/RecipientsChipInput';
import { sendReminderSchema } from '../schema';

export const getSendReminderFormDefinition = ({
    allowedInvoiceTemplateTypes,
    defaultLanguageCode,
    languages,
}: {
    allowedInvoiceTemplateTypes: FinancialDocumentPdfTemplateType[];
    defaultLanguageCode: string;
    languages: Option[] | GroupOption[];
}) =>
    ({
        renderFields: compactArray(['templateType', 'printLanguageCode', 'emails']),
        fields: {
            templateType: {
                label: lt('BillFormat'),
                render: (props, { fieldNames }) => {
                    return (
                        <FinancialDocumentTemplateSelectField
                            {...props}
                            name={fieldNames.templateType}
                            allowedTemplateTypes={allowedInvoiceTemplateTypes}
                        />
                    );
                },
            },
            printLanguageCode: {
                label: lt('Language'),
                field: {
                    type: 'select',
                    options: languages,
                    defaultValue: defaultLanguageCode,
                    virtualized: true,
                },
            },
            emails: {
                label: lt('Recipients'),
                helper: lt('SendReminderHelperText'),
                render: (props, { fieldNames }) => {
                    return <RecipientsChipInput {...props} name={fieldNames.emails} />;
                },
            },
        },
    }) satisfies SchemaFormDefinition<typeof sendReminderSchema>;
